<template>
  <div ref="wrapper" class="tab-wrap">
    <h1>
      <label>{{ title }}</label>
      <span
        v-if="moduleAnnotation != ''"
        class="ts-info iconfont icon-zhu"
        @click="isNotes()"
      ></span>
    </h1>
    <div class="show-box"></div>

    <!-- <div class="tabs-box">
      <van-tabs
        v-model="activeName"
        background="none"
        color="#4B84FF"
        line-width="20"
        title-active-color="#2F354D"
        title-inactive-color="#9095A7"
        swipe-threshold="1"
        @change="handleChange"
      >
        <van-tab
          v-for="item in tab"
          :name="item.name"
          :key="item.id"
          :title="item.title"
          title-class="badge-parent"
          :badge="item.badge"
        />
      </van-tabs>
    </div> -->
    <div class="null-box" v-if="isEmpty">
      <van-empty
        class="custom-image"
        image-size="100px"
        :image="require('../../../assets/not.png')"
        description="未检出"
      />
    </div>
    <GeneChildFx v-else :tabVal="tabVal" :dataList="dataList" />
    <!-- <div class="btn"> -->
    <!-- <div class="ts-info" @click="isNotes">
        <span>!</span>
        注释
      </div> -->
    <!-- <button @click="handleDetails('variationDetails')">
        体细胞变异结果<i class="iconfont icon-right_medium"></i>
      </button> -->
    <!-- </div> -->
    <!-- <TwoClass v-if="activeName == 'B'" /> -->
    <!-- 注释弹框 -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import GeneChildFx from "./components/geneChildFx.vue";
import isiOS from "@/utils/iosAn";

import { findPrognosis } from "@/api/reportQuery";

import { mapState } from "vuex";
export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default: "（分型/预后）有明确/潜在临床意义的基因变异",
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  components: {
    GeneChildFx,
  },
  data() {
    return {
      tabVal: 2,
      isEmpty: false,
      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
      activeName: 1,
      tab: [
        {
          title: "靶向药物",
          name: 1,
          badge: 0,
          id: 0,
        },
        {
          title: "分型/预后",
          badge: "",
          name: 2,
          id: 1,
          badge: 0,
        },
        // {
        //   title: "临床意义未明",
        //   badge: "",
        //   name: "C",
        //   id: 2,
        // },
      ],
      dataList: [],
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    // this.getTotal();
    this.getData();
    sessionStorage.setItem("typeTem", this.activeName);
  },
  methods: {
    // 点击跳转详情
    handleDetails(name) {
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/variation-details/variation-details?moduleId=1",
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name, type: "" }));
      }
      // this.$router.push({
      //   name: "variationDetails",
      //   query: {
      //     sessionId: this.$route.query.sessionId,
      //   },
      // });

      // window.webkit.messageHandlers.JSCallNative.postMessage(this.type);
    },
    isNotes() {
      // this.$refs.child.ishow();
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },
    // async getTotal() {
    //   try {
    //     let { data } = await ByTotal({
    //       labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
    //       productId: this.publicParams.productId,
    //       moduleId: this.templateId,
    //     });
    //     this.tab[0].badge = Number(data.mutationLabel1Size);
    //     this.tab[1].badge = Number(data.mutationLabel2Size);
    //     this.getData(2);
    //   } catch (error) {}
    // },
    getData() {
      this.$nextTick(async () => {
        try {
          let { data } = await findPrognosis({
            // labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
            labOriginalSampleNo: 'FP21104175T',
            productId: this.publicParams.productId,
            // mutationLabel: type,
            moduleId: this.templateId,
          });
          // console.log(data)
          this.dataList = data.map((item)=>{
            return {
              ...item,
              VAF:item.vaf,
              currentRate:Math.round(Number(item.vaf))
            }
          });
          console.log(this.dataList,2222222222);
          if (this.dataList == "") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
        } catch (error) {}
      });
    },
    handleChange(val) {
      console.log(val);
      this.tabVal = val;
      sessionStorage.setItem("tabVal", val);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.null-box {
  margin-top: -5px;
  padding-bottom: 20px;
  .van-empty__description {
    margin-top: 0;
    font-size: 13px;
    font-weight: 400;
    color: #a4a9bf;
    line-height: 18px;
  }
  .van-empty {
    padding: 0;
  }
}
.btn {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  button {
    width: 160px;
    height: 32px;
    background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
    box-shadow: 0px 4px 10px 0px rgba(75, 132, 255, 0.3);
    border-radius: 16px;
    outline: none;
    border: 0;
    font-size: 12px;
    font-family: @family;
    font-weight: 400;
    color: #ffffff;
    i {
      font-size: 10px;
    }
  }
}
.tab-wrap {
  // height: 790px;
  // padding-bottom: 30px;
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  padding-bottom: 10px;

  h1 {
    height: 70px;
    font-size: 18px;
    font-weight: 500;
    color: #2f354d;
    line-height: 70px;

    display: flex;
    justify-content: space-between;
    align-content: center;
    label {
      width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      text-indent: 24px;
    }
    .ts-info {
      color: #a4a9bf;
      margin-right: 14px;
    }
  }
  // .tabs-box {
  //   height: 70px;
  //   line-height: 70px;
  //   padding-top: 10px;
  //   box-sizing: border-box;
  //   position: relative;
  //   /deep/.van-tabs__nav--line{
  //     padding-bottom: 10px;
  //   }
  //   &::before {
  //     content: "";
  //     position: absolute;
  //     z-index: 1;
  //     right: 0;
  //     top: 0;
  //     height: 100%;
  //     width: 22px;
  //     background: rgba(244, 248, 253, 0.7);
  //   }
  // }
}
/deep/.badge-parent {
  min-width: 40%;
  .van-info {
    background: none;
    color: #4b84ff;
    border: 0;
    top: 6px;
    right: -6px;
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}

.tabs-box {
  box-sizing: border-box;
  position: relative;
  /deep/.van-tabs__nav--line {
    padding-bottom: 10px;
  }
  /deep/.van-tab__text {
    font-size: 15px;
    font-weight: 500;
  }
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    height: 100%;
    width: 22px;
    background: rgba(244, 248, 253, 0.7);
  }
}
</style>
